import InsuranceClaimHd from './ClaimHeader';
import ClaimList from './ClaimList';
import InsuranceList from './InsuranceList';
import InsuranceCRU from './InsuranceCRU';
import ClaimCRU from './ClaimCRU';
export { InsuranceClaimHd, InsuranceList, ClaimList, InsuranceCRU, ClaimCRU };

export const insuranceObj = {
    insurance_number: null,
    insurer: null,
    insuree: null,
    policy_start_date: null,
    policy_end_date: null,
    policy_renewal_date: null,
    re_insurer: null,
    geo_limit: null,
    currency: null,
    insurance_amount: null,
    deductible_amount: null,
    effective_date: null,
    primary_contact: null,
    variability: {},
    remarks: null,
    attachments: []
}
export const claimObj = {
    insurance_number: null,
    claim_number: null,
    amount:null,
    date_of_claim_closure: null,
    primary_contact: null,
    claim_details: null,
    approver: {},
    remarks: null,
}